import { render, staticRenderFns } from "./BannerGreetingCorporateUser.vue?vue&type=template&id=0e01b8e5&scoped=true&"
import script from "./BannerGreetingCorporateUser.vue?vue&type=script&lang=ts&"
export * from "./BannerGreetingCorporateUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e01b8e5",
  null
  
)

export default component.exports